import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Clinic } from './clinic.model';
import { Param } from '@core/models/Param';
import { DocumentClass } from '@core/models/DocumentClass';
import { Session } from '@core/models/Session';

export interface ClinicState extends EntityState<Clinic, string>, ActiveState {
    documentClasses: DocumentClass[];
    paramI: Param[];
    paramII: Param[];
    paramIII: Param[];
    paramIV: Param[];
    sessionList: Session[];
}

export function createInitialState(): Partial<ClinicState> {
    return {
        documentClasses: [],
        paramI: [],
        paramII: [],
        paramIII: [],
        paramIV: [],
        sessionList: []
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'clinic', idKey: 'id' })
export class ClinicStore extends EntityStore<ClinicState> {

    constructor() {
        super(createInitialState());
    }

}
